import { render, staticRenderFns } from "./workLeavesIndex.vue?vue&type=template&id=1dbcb7cd&"
import script from "./workLeavesIndex.vue?vue&type=script&lang=js&"
export * from "./workLeavesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports